<ion-content>
  <app-messaging></app-messaging>
</ion-content>
